export default __webpack_public_path__ + "static/media/guia-mobile-4.9248562d.png";